import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'topo-related-documents-filter',
    templateUrl: './related-documents-filter.component.html',
    styleUrls: ['./related-documents-filter.component.scss'],
    standalone: false
})
export class RelatedDocumentsFilterComponent implements OnInit, OnDestroy {
  @Output() openTable: EventEmitter<any> = new EventEmitter();
  @Output() search: EventEmitter<string> = new EventEmitter();

  destroy$ = new Subject<void>();
  searchControl: FormControl = new FormControl();

  constructor() { }

  ngOnInit(): void {
    this.searchControl.valueChanges.pipe(debounceTime(400), takeUntil(this.destroy$)).subscribe(searchTerm => this.onSearch(searchTerm));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  onOpenTable() {
    this.openTable.emit();
  }

  private onSearch(searchTerm: string): void {
    this.search.emit(searchTerm);
  }
}
